import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const menuItems = [
    { label: "Home", href: "/", type: "link" },
    { label: "About", href: "about", type: "scroll" },
    { label: "Skills", href: "skills", type: "scroll" },
    { label: "Experiences", href: "experiences", type: "scroll" },
    { label: "Research", href: "research", type: "scroll" },
    { label: "Research Tracks", href: "/research", type: "link" },
    { label: "Awards & Media", href: "awards", type: "scroll" },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = (sectionId) => {
    if (!isHomePage) {
      // 홈페이지가 아니면 먼저 홈으로 이동
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // 홈페이지면 바로 스크롤
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    setIsOpen(false);
  };

  return (
    <nav className="bg-black/80 backdrop-blur-xl text-white fixed top-0 left-0 w-full z-50 border-b border-white/10 px-4 sm:px-8 py-4 transition-all duration-300">
      <div className="flex justify-between items-center">
        <Link to="/" className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-white via-teal-200 to-blue-200 bg-clip-text text-transparent">
          Mintai Kim
        </Link>

        {/* Enhanced mobile menu button */}
        <button
          className="sm:hidden w-10 h-10 rounded-xl bg-white/10 border border-white/20 flex items-center justify-center text-xl hover:bg-white/20 transition-all duration-200 transform hover:scale-105"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span className={`transform transition-transform duration-300 ${
            isOpen ? "rotate-90" : "rotate-0"
          }`}>
            ☰
          </span>
        </button>

        {/* Enhanced desktop menu */}
        <ul className="hidden sm:flex space-x-2 text-sm font-medium">
          {menuItems.map((item, index) => (
            <li key={item.label}>
              {item.type === "link" ? (
                <Link
                  to={item.href}
                  className="relative px-4 py-2 rounded-xl text-white/80 hover:text-white transition-all duration-300 group overflow-hidden block"
                >
                  {/* Hover background effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-teal-500/20 to-blue-500/20 rounded-xl scale-0 group-hover:scale-100 transition-transform duration-300 origin-center"></div>

                  {/* Border glow effect */}
                  <div className="absolute inset-0 rounded-xl border border-transparent group-hover:border-teal-400/30 transition-all duration-300"></div>

                  {/* Text content */}
                  <span className="relative z-10 group-hover:text-white transition-colors duration-300">
                    {item.label}
                  </span>
                </Link>
              ) : (
                <button
                  onClick={() => handleScroll(item.href)}
                  className="relative px-4 py-2 rounded-xl text-white/80 hover:text-white transition-all duration-300 group overflow-hidden block"
                >
                  {/* Hover background effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-teal-500/20 to-blue-500/20 rounded-xl scale-0 group-hover:scale-100 transition-transform duration-300 origin-center"></div>

                  {/* Border glow effect */}
                  <div className="absolute inset-0 rounded-xl border border-transparent group-hover:border-teal-400/30 transition-all duration-300"></div>

                  {/* Text content */}
                  <span className="relative z-10 group-hover:text-white transition-colors duration-300">
                    {item.label}
                  </span>
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* Enhanced mobile menu dropdown */}
      <div className={`sm:hidden overflow-hidden transition-all duration-300 ${
        isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
      }`}>
        <div className="mt-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-4">
          <ul className="flex flex-col space-y-1 text-sm font-medium">
            {menuItems.map((item, index) => (
              <li key={item.label}>
                {item.type === "link" ? (
                  <Link
                    to={item.href}
                    className="group flex items-center gap-3 px-4 py-3 rounded-xl text-white/80 hover:text-white hover:bg-white/10 transition-all duration-200 border border-transparent hover:border-white/20"
                    onClick={() => setIsOpen(false)}
                  >
                    <div className="w-2 h-2 bg-gradient-to-r from-teal-400 to-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                    <span>{item.label}</span>
                  </Link>
                ) : (
                  <button
                    onClick={() => handleScroll(item.href)}
                    className="group flex items-center gap-3 px-4 py-3 rounded-xl text-white/80 hover:text-white hover:bg-white/10 transition-all duration-200 border border-transparent hover:border-white/20 w-full text-left"
                  >
                    <div className="w-2 h-2 bg-gradient-to-r from-teal-400 to-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                    <span>{item.label}</span>
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
